module.exports = __webpack_public_path__ + "static/img/12.1.f62bc97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/12.1.png
// module id = yC38
// module chunks = 0